import { render, staticRenderFns } from "./NavigationPanelForEntity.vue?vue&type=template&id=779c5bb8&"
import script from "./NavigationPanelForEntity.vue?vue&type=script&lang=js&"
export * from "./NavigationPanelForEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports